import React, { useEffect, useState, useLayoutEffect } from "react";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import axios from "axios";
import SubNav from "../../Layout/SubNav";
import SocialFeed from "../../Components/BlogComp/SocialFeed";
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const SelectBlog = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();
  const [blogData, setBlogData] = useState([]);

  const fetchBlog = async () => {
    const res = await axios.get(
      "https://staging-cms-main.ipurvey.com/blogs/" + id
    );
    setBlogData(res.data);
  };

  useEffect(() => {
    fetchBlog();
  }, [id]);
  return (
    <div>
      <div className="blog_container">
        <SubNav head="ipurvey Blogs" />
        <div className="blog_main_div">
          <div className="select_blog_para_data">
            <h5>
              <strong>{blogData?.blog?.title}</strong>
            </h5>
            <div className="one_blog_data_div">
              <p>{new Date(blogData?.blog?.createdAt).toDateString()}</p>
            </div>
          </div>
          <div className="blog_card_socail_feed_div">
            <div className="select_blog_more_main_div">
              <Swiper
                spaceBetween={50}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log("slide change")}
                className="swiper_slider_blog"
              >
                {blogData?.blog?.gallery?.map((data) => (
                  <SwiperSlide>
                    <img
                      width="100%"
                      src={`https://staging-cms-main.ipurvey.com${
                        data?.formats?.large?.url ?? data?.url
                      }`}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="select_blog_more_para">
                <ReactMarkdown>{blogData?.blog?.content}</ReactMarkdown>
              </div>
            </div>
            <SocialFeed />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectBlog;
